var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialTgWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social_tg_white",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.545455,12 C0.545455,8.83691331 1.82754784,5.97327702 3.90041243,3.90041243 C5.97327702,1.82754784 8.83691331,0.545455 12,0.545455 C15.1630796,0.545455 18.0267177,1.82755003 20.099585,3.90041734 C22.1724491,5.97328151 23.454545,8.83691572 23.454545,12 C23.454545,15.1630771 22.172447,18.0267132 20.0995801,20.0995801 C18.0267132,22.172447 15.1630771,23.454545 12,23.454545 C8.83691572,23.454545 5.97328151,22.1724491 3.90041734,20.099585 C1.82755003,18.0267177 0.545455,15.1630796 0.545455,12 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 1.09091
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43201,11.8732 C8.93026,10.3491 11.263,9.3443 12.4301,8.85881 C15.7627,7.4727 16.4551,7.23191 16.9065,7.22379791 C17.0058,7.22221 17.2277,7.24681 17.3715,7.36348 C17.4929,7.46199 17.5263,7.59506 17.5423,7.68845 C17.5583,7.78185 17.5782,7.99461 17.5623,8.16085 C17.3817,10.0583 16.6003,14.663 16.2028,16.7882 C16.0346,17.6875 15.7034,17.989 15.3827,18.0185 C14.6858,18.0827 14.1567,17.558 13.4817,17.1156 C12.4256,16.4232 11.8289,15.9923 10.8037,15.3167 C9.619,14.5359 10.387,14.1068 11.0622,13.4055 C11.2389,13.222 14.3093,10.4292 14.3687,10.1759 C14.3762,10.1442 14.3831,10.0261 14.3129,9.9637 C14.2427,9.9014 14.1392,9.9227 14.0644,9.9396 C13.9585,9.9637 12.2713,11.0789 9.0028,13.2852 C8.52385,13.6141 8.09007,13.7743 7.70141,13.7659 C7.27295,13.7567 6.44876,13.5237 5.83606,13.3245 C5.08456,13.0802 4.48728,12.9511 4.53929,12.5362 C4.56638,12.3201 4.86395,12.0991 5.43201,11.8732 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTgWhite);
export default __webpack_public_path__ + "static/media/social_tg_white.33520dc6.svg";
export { ForwardRef as ReactComponent };